function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "letter_s"
}, /*#__PURE__*/React.createElement("path", {
  className: "fill-white",
  d: "M37.5,30.5H10.9v-6.6h34.3c-0.9-2.8-3.8-5.4-8.9-5.4H11.4c-5.7,0-9,2.1-9,6.7v4.9c0,4,3.4,6.3,8.4,6.3h26.9v7H1.5           c0.9,3.8,3.8,5.8,9,5.8h27.1c5.7,0,8.5-2.2,8.5-6.9v-4.9C46.1,33.1,42.8,30.8,37.5,30.5z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "letter_p"
}, /*#__PURE__*/React.createElement("path", {
  className: "fill-white",
  d: "M91.8,18.6H59v30.7h9.3V37.5h24.2c6.7,0,10.4-2.3,10.4-7.7v-3.4C102.8,21.4,98.6,18.6,91.8,18.6z M94.8,28.4           c0,2.2-0.4,3.4-4,3.4H68.3l0.1-8h22c4,0,4.5,1.2,4.5,3.3V28.4z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  className: "letter_a"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "fill-white",
  points: "129.9,17.3 124.3,24.2 133.8,37.3 114,37.3 109.1,42.5 137.7,42.5 142.6,49.3 153.6,49.3  "
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  className: "letter_c"
}, /*#__PURE__*/React.createElement("path", {
  className: "fill-white",
  d: "M171.4,23.9h34.8c-0.9-3.6-4.4-5.4-9.4-5.4h-26c-4.5,0-8.8,1.8-8.8,6.7v17.2c0,4.9,4.3,6.7,8.8,6.7h26.3           c6,0,8.1-1.7,9.1-5.8h-34.8V23.9z"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  className: "letter_e"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "fill-white",
  points: "228.3,43.5 228.3,34.1 247,34.1 247,28.9 218.9,28.9 218.9,49.3 260.4,49.3 260.4,43.5  "
}), /*#__PURE__*/React.createElement("rect", {
  className: "fill-white",
  x: 219.9,
  y: 18.6,
  width: 41.9,
  height: 5.4
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  className: "letter_x"
}, /*#__PURE__*/React.createElement("path", {
  className: "fill-white",
  d: "M287.6,18.6H273l17.2,12.6c2.5-1.7,5.4-3.5,8-5L287.6,18.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "fill-white",
  d: "M308.8,34.3c-2.5,1.7-5,3.6-7.4,5.4l13,9.5h14.7L308.8,34.3z"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  className: "letter_swoosh"
}, /*#__PURE__*/React.createElement("path", {
  className: "fill-white",
  d: "M399,0.7c-80,4.6-117,38.8-125.3,46.9l-1.7,1.6h14.8C326.8,9.1,384.3,2,399,0.7L399,0.7z"
}));

function SvgSpacex(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SpaceX Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpacex);
export default __webpack_public_path__ + "static/media/spacex.1ad94f58.svg";
export { ForwardRef as ReactComponent };